/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Components
import Header from '../components/header';
// Images
import ErrorImg from '../assets/images/404.svg';
// React Router
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Error = () => {
    let navigate = useNavigate();


    return (
        <main>
            <div className="home-hero pb-28">
                <Header />
            </div>
            <section className='error max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 pt-10 pb-28'>
                <img src={ErrorImg} alt="404 Error" className='block mx-auto mb-8' />
                <h1 className='text-gray-100 text-4xl font-semibold text-center mb-7'>Page not Found</h1>
                <p className='text-gray-300 text-xl text-center mb-12'>We suggest you go back to the homepage while we fix the problem</p>
                <div className='flex justify-center items-center'>
                    <a onClick={() => navigate(-1)} className="bg-white w-44 text-center py-3.5 text-gray-900 font-semibold cursor-pointer rounded-full mr-6 select-none">
                        Go back
                    </a>
                    <Link to="/" className="bg-primary hover:bg-secondary w-44 text-center py-3.5 text-gray-100 cursor-pointer hover:text-white rounded-full transition select-none">
                        Return home
                    </Link>
                </div>
            </section>
        </main>
    )
}

export default Error